/*
 * @Author:lvbl
 * @Date: 2021-07-16 17:11:43
 * @LastEditors: 王璐 wanglu@longjitech.com
 * @Description: 组件全局注册
 * @FilePath: /ljsite-vue/src/core/nportal_use.js
 */
import Vue from "vue";
import config from "../config/defaultSettings";
import VueStorage from "vue-ls";
import BaiduMap from "vue-baidu-map";
//首页所需行业通知等豆腐块
//首页所需 Banner图组件
Vue.component("BannerTop", () =>
  import("@/views/nportal/components/home/BannerTop")
);
//首页所需 产品体系组件
Vue.component("ProductSystem", () =>
  import("@/views/nportal/components/home/ProductSystem")
);
//首页所需 典型案例组件
Vue.component("TypicalCase", () =>
  import("@/views/nportal/components/home/TypicalCase")
);
//首页所需 服务客户组件
Vue.component("ServeClients", () =>
  import("@/views/nportal/components/home/ServeClients")
);
Vue.component("EcologicalPartners", () =>
  import("@/views/nportal/components/home/EcologicalPartners")
);
Vue.component("CardList", () =>
  import("@/views/nportal/components/home/CardList")
);

Vue.component("varduserdemo", () =>
  import("@/views/nportal/components/home/varduserdemo")
);
//首页所需 创新驱动-数字中台列表组件
Vue.component("CardNav", () =>
  import("@/views/nportal/components/home/CardNav")
);
//首页所需 新闻资讯
Vue.component("DynamicNews", () =>
  import("@/views/nportal/components/home/DynamicNews")
);
//首页所需 经典案例
Vue.component("ClassicCase", () =>
  import("@/views/nportal/components/home/ClassicCase")
);
//首页所需 服务客户
Vue.component("ServingCtr", () =>
  import("@/views/nportal/components/home/ServingCtr")
);
//首页所需 服务优势
Vue.component("ServingAdv", () =>
  import("@/views/nportal/components/home/ServingAdv")
);
//----------------------------------支持与服务-----------------------------------------------//
//支持与服务所需   全方位售后与运维服务
Vue.component("AfterSale", () =>
  import("@/views/nportal/components/surport/AfterSale")
);
//支持与服务所需   360度敏捷响应
Vue.component("Response", () =>
  import("@/views/nportal/components/surport/Response")
);
//支持与服务所需   在线咨询
Vue.component("Online", () =>
  import("@/views/nportal/components/surport/Online")
);

//支持与服务所需-new   服务优势
Vue.component("afterService", () =>
  import("@/views/nportal/components/surport/afterService")
);
//支持与服务所需-new   全国服务网点覆盖
Vue.component("afterNetwork", () =>
  import("@/views/nportal/components/surport/afterNetwork")
);
//支持与服务所需-new   技术服务团队
Vue.component("afterTeam", () =>
  import("@/views/nportal/components/surport/afterTeam")
);
//----------------------------------招贤纳士-----------------------------------------------//
//招贤纳士
Vue.component("Recruit", () =>
  import("@/views/nportal/components/recruit/Recruit")
);

//--------------产品方案--信创项目---new---------------------------------------//
Vue.component("xcnumlog", () =>
  import("@/views/nportal/components/Schemes/numlog/index.vue")
);
Vue.component("wisdom", () =>
  import("@/views/nportal/components/Schemes/wisdom/index.vue")
);
Vue.component("mobile", () =>
  import("@/views/nportal/components/Schemes/mobile/index.vue")
);
Vue.component("system", () =>
  import("@/views/nportal/components/Schemes/system/index.vue")
);

Vue.component("xinchuang", () =>
  import("@/views/nportal/components/Schemes/xinchuang/index.vue")
);

//----------------------关于龙即----------------------------------------------//
// 关于龙即整页
Vue.component("aboutLongji_total", () =>
  import("@/views/nportal/components/about/aboutLongji_total.vue")
);

Vue.component("about", () =>
  import("@/views/nportal/components/about/about.vue")
);
Vue.component("develop", () =>
  import("@/views/nportal/components/about/comp/develop.vue")
);

Vue.component("aboutIntroduce", () =>
  import("@/views/nportal/components/about/comp/aboutIntroduce.vue")
);

Vue.component("honor", () =>
  import("@/views/nportal/components/about/comp/honor.vue")
);
Vue.component("news", () =>
  import("@/views/nportal/components/about/comp/news.vue")
);
Vue.component("contactme", () =>
  import("@/views/nportal/components/about/comp/contactme.vue")
);

Vue.component("aboutTitle", () =>
  import("@/views/nportal/components/about/comp/aboutTitle.vue")
);
//----------------------产品与方案-------------
Vue.component("ProductXinChuangType", () =>
  import("@/views/nportal/components/product/ProductXinChuangType.vue")
);
Vue.component("TestStyle", () =>
  import("@/views/nportal/components/product/TestStyle.vue")
);
//产品与方案 信创政务
Vue.component("ProductSys", () =>
  import("@/views/nportal/components/product/ProductSys.vue")
); //产品与方案 系统方案

//----------------------关于龙即新-------------
Vue.component("aboutLongjiHeader", () =>
  import("@/views/nportal/components/about/aboutLongjiHeader.vue")
); //关于龙即头部
Vue.component("aboutComIntro", () =>
  import("@/views/nportal/components/about/com/aboutComIntro.vue")
); //关于龙即企业介绍
Vue.component("AboutComCulture", () =>
  import("@/views/nportal/components/about/com/AboutComCulture.vue")
); //关于龙即企业文化
Vue.component("AboutComAllChina", () =>
  import("@/views/nportal/components/about/com/AboutComAllChina.vue")
); //关于龙即全国网点
Vue.component("AboutDevImg", () =>
  import("@/views/nportal/components/about/com/AboutDevImg.vue")
); //关于龙即发展历程图片
Vue.component("AboutDevHisLine", () =>
  import("@/views/nportal/components/about/com/AboutDevHisLine.vue")
); //关于龙即发展历程图片
Vue.component("AboutAhonor", () =>
  import("@/views/nportal/components/about/com/AboutAhonor.vue")
); //关于龙即资质荣誉
Vue.component("AboutNews", () =>
  import("@/views/nportal/components/about/com/AboutNews.vue")
); //关于龙即新闻资讯
//----------------------客户案例----------------------------------------------//
//客户案例头部
Vue.component("customImage", () =>
  import("@/views/nportal/components/case/Index.vue")
);

//官网改版
Vue.component("Shuze", () =>
  import("@/views/nportal/components/product/Shuze.vue")
);
Vue.component("Shukun", () =>
  import("@/views/nportal/components/product/Shukun.vue")
);
Vue.component("Shuluan", () =>
  import("@/views/nportal/components/product/Shuluan.vue")
);
Vue.component("Shulin", () =>
  import("@/views/nportal/components/product/Shulin.vue")
);
Vue.component("lingyuan", () =>
  import("@/views/nportal/components/product/lingyuan.vue")
);
Vue.component("NewsAndInfo", () =>
  import("@/views/nportal/components/about/com/NewsAndInfo.vue")
);
//引入本地存储
Vue.use(BaiduMap, {
  ak: "mo5a3PpG04lGwVuFgRuYL9SrTxxSE9YU",
});

Vue.use(VueStorage, config.localStorageOptions);
Vue.use({ ...VueStorage }, config.sessionStorageOptions);
